export default __webpack_public_path__ + "static/media/preview-equipment-media.b0a5f2c4.jpg";